import React from 'react';

const FilterContext = React.createContext({});

export const FilterProvider = FilterContext.Provider;

export default FilterContext;
